import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.16895 10.0005L5.16894 13.6672L5.16894 7.00049M5.16894 3.00049L5.16894 4.66715"
        stroke="black"
        strokeOpacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16894 10.0005L5.16894 13.6672L5.16895 7.00049M5.16895 3.00049L5.16895 4.66715"
        stroke="black"
        strokeOpacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_1723_7638)">
        <path
          d="M1.16797 10.001L5.16797 13.6676L5.16797 7.00098M5.16797 3.00098L5.16797 4.66764"
          stroke="black"
          strokeOpacity="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1723_7638">
          <rect width="4" height="4.66667" fill="white" transform="translate(5.83496 2.33398) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
